// Single epoch detail from sui_getCheckpoints (LOCAL / CPC fullnode).

import { useSuiClient } from '@mysten/dapp-kit';
import { useQuery } from '@tanstack/react-query';

import { fetchCpcEpochByNumber } from '~/utils/cpcEpochFromCheckpoints';

export function resolveCpcEpochId(
	id: string | undefined,
	currentEpoch: string | number | undefined,
): number | null {
	if (!id || id === 'current') {
		if (currentEpoch == null || currentEpoch === '') return null;
		const n = Number(currentEpoch);
		return Number.isFinite(n) ? n : null;
	}
	const n = Number(id);
	return Number.isFinite(n) && n >= 0 ? n : null;
}

export function useCpcEpochDetail(epochId: string | undefined) {
	const client = useSuiClient();

	return useQuery({
		queryKey: ['cpc-epoch-detail', epochId],
		queryFn: async () => {
			const system = await client.getLatestSuiSystemState();
			const target = resolveCpcEpochId(epochId, system.epoch);
			if (target == null) return null;
			const summary = await fetchCpcEpochByNumber(client, target);
			if (!summary) return null;
			const epochStartMs =
				summary.epochStartTimestamp ??
				(summary.isCurrent && system.epochStartTimestampMs
					? Number(system.epochStartTimestampMs)
					: null);
			return {
				summary,
				epochStartMs,
				systemEpoch: Number(system.epoch),
				epochDurationMs: Number(system.epochDurationMs ?? 0),
			};
		},
		staleTime: 30_000,
		retry: 2,
	});
}
